export function isSet(value) {
    return value !== undefined && value !== null;
}
//# sourceMappingURL=isSet.js.map